/*
 * Copyright 2025 Intuition Robotics ltd
 */
import * as React from "react";
import {useContext} from "react";
import {useLocation} from "react-router-dom";
import {PARAM_PATIENT} from "@modules/UserPreferencesModule";
import {RoutingModule} from "@intuitionrobotics/thunderstorm/frontend";
import {Route_Default} from "../Routes";
import {PatientsContext} from "./ui/patients/PatientsContext";
import {DB_Patient} from "@app/app-shared/patient";

export const PatientProvider = ({children}: { children: (patient: DB_Patient) => React.ReactNode }) => {
    const selectedPatient = useSelectedPatient();
    if (!selectedPatient)
        return null;

    return children(selectedPatient);
}

export const useSelectedPatient = () => {
    const {search} = useLocation();
    const queryParams = new URLSearchParams(search);
    const selectedPatientId = queryParams.get(PARAM_PATIENT);
    if (!selectedPatientId)
        return RoutingModule.goToRoute(Route_Default);

    const {patients} = useContext(PatientsContext)
    const selectedPatient = patients[selectedPatientId];
    if (!selectedPatient)
        return RoutingModule.goToRoute(Route_Default);

    return selectedPatient;
}